import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './lifestyle-item.component.scss';
var LifestyleItem = /** @class */ (function (_super) {
    tslib_1.__extends(LifestyleItem, _super);
    function LifestyleItem(element) {
        return _super.call(this, element) || this;
    }
    LifestyleItem.prototype.init = function () { };
    ;
    LifestyleItem.prototype.bindEvents = function () { };
    ;
    return LifestyleItem;
}(Base));
export { LifestyleItem };



//////////////////
// WEBPACK FOOTER
// ./components/lifestyle-item/lifestyle-item.component.ts
// module id = 397
// module chunks = 0